export const FIELD_META_PROP = 'data-__meta';



// WEBPACK FOOTER //
// ./_antd1.11.2/form/constants.js